// Omnix/client/ui/TelegramWizard.js
import { ComponentBase } from "../core/ComponentBase.js";

export class TelegramWizard extends ComponentBase {
    constructor(config) {
        super(config);
        this.modalInstance = null;
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'modal fade';
        this.container.id = `${this.config.instanceId}-modal`;
        this.container.setAttribute('tabindex', '-1');
        this.container.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Telegram Bot Setup</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted">Create a bot using the 'BotFather' in your Telegram app to get a token, then paste it here.</p>
                        <div class="mb-3"><label class="form-label">Bot Name</label><input type="text" id="tg-name" class="form-control" placeholder="e.g., My Company Support Bot"></div>
                        <div class="mb-3"><label class="form-label">Bot Token</label><textarea id="tg-token" class="form-control" rows="3" placeholder="Paste your token from BotFather here"></textarea></div>
                        
                        <h6 class="mt-3">Routing</h6>
                        <div class="mb-3">
                            <label for="tg-workflow-select" class="form-label">Inbound Workflow</label>
                            <select id="tg-workflow-select" class="form-select">
                                <option value="">Default (Direct to Inbox)</option>
                            </select>
                            <div class="form-text">Select a workflow to handle incoming messages. Workflows must be tagged with 'messaging'.</div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" id="wizard-finish-btn">Test & Save</button>
                    </div>
                </div>
            </div>
        `;
        this.modalInstance = new bootstrap.Modal(this.container);
        this.container.querySelector('#wizard-finish-btn').addEventListener('click', this.handleFinish.bind(this));
        await super.initialize();
    }

    async show() {
        this.container.querySelectorAll('input, textarea, select').forEach(el => el.value = '');
        this.modalInstance.show();
        await this._populateWorkflows();
    }

    async _populateWorkflows() {
        const select = this.container.querySelector('#tg-workflow-select');
        if (!select) return;
        try {
            const workflows = await this.appClient.rpcClient.call('ChannelManagerRpc.getFieldValues', {
                fieldName: 'inboundWorkflowId',
                reference: {
                    collection: 'workflows', valueField: '_id', displayField: 'name',
                    filter: { tags: 'messaging' }
                }
            });
            select.innerHTML = '<option value="">Default (Direct to Inbox)</option>';
            workflows.forEach(wf => {
                const option = document.createElement('option');
                option.value = wf.value;
                option.textContent = wf.label;
                select.appendChild(option);
            });
        } catch (error) {
            this.log.error("Failed to populate workflows in TelegramWizard:", error);
        }
    }


    async handleFinish() {
        const finishBtn = this.container.querySelector('#wizard-finish-btn');
        finishBtn.disabled = true;
        finishBtn.innerHTML = `<span class="spinner-border spinner-border-sm"></span> Testing...`;
        const workflowId = this.container.querySelector('#tg-workflow-select').value;

        const config = {
            name: this.container.querySelector('#tg-name').value.trim(),
            channelType: 'telegram',
            provider: 'telegram',
            isEnabled: true,
            inboundWorkflowId: workflowId || null,

            credentials: {
                botToken: this.container.querySelector('#tg-token').value.trim(),
            }
        };

        if (!config.name || !config.credentials.botToken) {
            this.appClient.notifier.error("Bot Name and Bot Token are required.");
            finishBtn.disabled = false;
            finishBtn.textContent = 'Test & Save';
            return;
        }

        try {
            await this.appClient.rpcClient.call('ChannelManagerRpc.setupProvider', {
                providerName: 'telegram',
                command: 'wizard_validate_credentials',
                args: { botToken: config.credentials.botToken }
            });

            await this.appClient.rpcClient.call('ChannelManagerRpc.create', config);

            this.appClient.notifier.success(`Telegram bot '${config.name}' configured successfully!`);
            this.emit('channelSaved');
            this.modalInstance.hide();
        } catch (error) {
            this.appClient.notifier.error(`Setup failed: ${error.message}`);
        } finally {
            finishBtn.disabled = false;
            finishBtn.textContent = 'Test & Save';
        }
    }

    render() { return this.container; }
    destroy() { this.modalInstance?.dispose(); this.container?.remove(); super.destroy(); }
}